import React, { useEffect, useState, useRef, useCallback } from 'react';
import AdminLayoutWrapper from '../AdminLayoutWrapper';
import { listTeamServices } from '../../../apis/teams';
import { Button, Table, Breadcrumb, Card, Space, Select, Spin } from 'antd';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router';
import { PlusCircleOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import EditInput from '../../common/EditInput';
import { updateServiceEntryById } from '../../../apis/serviceEntry';

const styles = {
  'primaryLabel': {
    fontSize: 18,
    fontWeight: 700
  },
  secondLabel: {
    fontSize: 16,
    fontWeight: 400
  }
}

const ListTeamService = ({ user }) => {
  const [teamServices, setTeamServices] = useState([]);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  const inputRef = useRef(null);

  const fetchTeamServices = useCallback(async () => {
    try {
      if (id ?? false) {
        setLoading(true);
        const { data: result } = await listTeamServices(id);
        setTeamServices(result);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [id])

  const handleUpdateServiceName = async (serviceId) => {
    try {
      setLoading(true);
      await updateServiceEntryById(serviceId, {
        name: inputRef?.current?.state?.value || null
      });
      setLoading(false);
      // call api get team services 
      await fetchTeamServices();
    } catch (error) {
      setLoading(false);
      await fetchTeamServices();
      console.log('error', error);
    }
  }

  const handleUpdateServiceDomainGroup = async (serviceId, domainGroup) => {
    try {
      setLoading(true);
      await updateServiceEntryById(serviceId, {
        domain_group: domainGroup
      });
      setLoading(false);
      // call api get team services 
      await fetchTeamServices();
    } catch (error) {
      setLoading(false);
      await fetchTeamServices();
      console.log('error', error);
    }
  }

  const columns = [
    {
      title: 'Service Name',
      dataIndex: 'name',
      render: (value, record) => {
        return (
          <Space>
            <EditInput
              labelStyle={styles.primaryLabel}
              contentStyle={styles.secondLabel}
              inputRef={inputRef}
              onSubmit={() => handleUpdateServiceName(record.id)}
              value={value}
            />
          </Space>
        )
      }
    },
    {
      title: 'Domain Group',
      dataIndex: 'domain_group',
      render: (value, record) => {
        return (
          <Space>
            <Select
                style={{ width: 200 }}
                onSelect={(domainGroup) => handleUpdateServiceDomainGroup(record.id, domainGroup)}
                value={value}
              >
                <Select.Option value="Marketplace">MARKETPLACE</Select.Option >
                <Select.Option value="Architecture">ARCHITECTURE</Select.Option >
                <Select.Option value="TNSL">TNSL</Select.Option >
                <Select.Option value="Others">OTHERS</Select.Option >
                <Select.Option value="Draft">DRAFT</Select.Option >
              </Select>
          </Space>
        )
      }
    },
    {
      title: 'Description',
      dataIndex: 'description',
    },
  ];

  const isAdmin = user && user.admin;

  useEffect(() => {
    fetchTeamServices();
  }, [fetchTeamServices])

  return (
    <AdminLayoutWrapper>
      <Spin spinning={loading}>
        <div style={{ padding: '0px 0px 16px 0px' }}>
          <Breadcrumb>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/teams/me`}>Manage Team</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              Team Services
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <Card>
          {
            isAdmin && (
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'flex-end'
                }}
              >
                <Link to={`/admin/teams/${id}/services/assign`}>
                  <Button type="primary">Assign Services <PlusCircleOutlined /></Button>
                </Link>
              </div>
            )
          }

          <br />
          <div>
            <Table
              dataSource={teamServices}
              columns={columns}
            />
          </div>
        </Card>
      </Spin>
    </AdminLayoutWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.app.user
  }
}

export default connect(mapStateToProps)(ListTeamService);
